export * from "ce/pages/workspace/WorkspaceInviteUsersForm";
import { default as CE_Workspace_Invite_Users_Form } from "ce/pages/workspace/WorkspaceInviteUsersForm";
export default CE_Workspace_Invite_Users_Form;
